import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { ProjectsService } from '@app/services/app/projects.service';
import { AppService } from '@app/services/app/app.service';
import { VersionsService } from '@app/services/app/versions.service';
import { AppRouterService } from '@app/services/app/router.service';
import { AddProjectService } from '@app/services/app/add-project.service';
import { ProjectsEditorService } from 'app/services/app/projects.service';

import * as Objects from '@core/objects';
import { VersionShareItem } from '@core/models/version-share.model';
import { NotificationsService } from '@core/services/notifications/notifications.service';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { VersionListItemMenuClick } from '@core/components/versions/list/version-list-item-menu-click';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';


@Component({
    selector: 'project-details-versions-relateds-list-versions',
    templateUrl: './relateds-list-versions.component.html',
    styleUrls: ['./relateds-list-versions.component.scss']
})
export class ProjectDetailsVersionsRelatedsListVersionsComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly ERROR = 2;

    public readonly RELATED_VERSIONS_CONTEXT = 'project-related-versions-group';
    protected readonly ACCESS_REQUEST_FEEDBACK = 'share_feedback';
    protected readonly ACCESS_ADD_PROJECT = "access_global_new_request";
    protected readonly ACCESS_UPLOAD_VERSION = "access_request_upload_version";

    @Input() related: Objects.RelatedVersions;
    @Input() project: Objects.Request;

    public status:number = this.LOADING;
    // public feedbackPluginAccess: boolean = false;
    public addProjectAccess: boolean = false;
    public versions: Array<Objects.Version> = [];
    public uploadedVersions: Array<Objects.Version> = [];
    public feedbacks: Array<VersionShareItem> = null;

    public futureStatus: Array<Objects.Status> = [];


    protected uploadeSubscriptor: Subscription;
    protected feedbacksSubscriptor: Subscription;
    protected accessUploadSubscriptor: Subscription;

    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "Download All Files",
            key: "download-all",
            icon: "download",
            order: 1
        },
        {
            title: "See Artwork Details",
            key: "details",
            icon: "see-details",
            order: 3
        },
        // MAYBE CHECK EITHER ARTWORK IS UPLOADED OR NOT TO REMOVEE THIS MENU
        {
            title: "See Original Project",
            key: "see-project",
            icon: "see-project",
            order: 4
        }
    ];

    // optional menu item
    protected menuAddProject: ThreeDotsMenuItem = {
        title: "Start New Project",
        key: "add-project",
        icon: "add",
        order: 5
    };

    protected uploadMenuItem: ThreeDotsMenuItem = {
        title: "Upload Artwork",
        key: "upload-artwork",
        icon: "upload_artwork",
        order: 2
    };


    constructor( public app: AppService, private versionsSrv: VersionsService, private projectsSrv: ProjectsService,
        private AddProjectSrv: AddProjectService,
        private appRouter: AppRouterService,
        private activatedRoute: ActivatedRoute,
        private notifSrv: NotificationsService,
        private editorSrv: ProjectsEditorService ) { }

    ngOnInit() {
        // get access
        this.app.getSession().subscribe( (session: any) => {
            this.addProjectAccess = session.options.access.hasOwnProperty(this.ACCESS_ADD_PROJECT)? session.options.access[this.ACCESS_ADD_PROJECT] : false;
            this.updateMenu(this.menuAddProject,this.addProjectAccess);
        });

        // subscribe to access of upload versions
        this.accessUploadSubscriptor = this.editorSrv.selectAccess(this.ACCESS_UPLOAD_VERSION).subscribe((access: boolean) => {
            this.updateMenu(this.uploadMenuItem,access);
        });

        // new subscriber for the feedbacks in the project store
        this.feedbacksSubscriptor = this.projectsSrv.selectVersionsFeedbacks(this.related.versions).subscribe((feedbacks: VersionShareItem[]) => {
            this.feedbacks = feedbacks;
        });

        this.uploadeSubscriptor = this.projectsSrv.selectUploadedVersions().subscribe((versions: Array<Objects.Version>) => this.uploadedVersions = versions);
        this.initView();

    }

    ngOnDestroy() {
        this.accessUploadSubscriptor.unsubscribe();
        this.feedbacksSubscriptor.unsubscribe();
        this.uploadeSubscriptor.unsubscribe();
    }

    initView() : void {
        if(this.related.versions.length == 0)
            return;
        
        this.status = this.DONE;
    }

    onMenuClick(menu: VersionListItemMenuClick) {
        // console.debug(" menu version item  click ",menu);
        switch(menu.key) { 
            case "download-all":
                // start notification to download compressed version files in zip
                this.notifSrv.addNotification(NotificationsContextEnum.EVENT_FILES_COMPRESSION_START, {id: menu.version.id,details: { url: "/versions/"+menu.version.id}});
                break;
            case "upload-artwork":
                this.appRouter.navigate('/projects/'+this.project.id+'/versions/add', { queryParams: { links: this.related.id }});
                break;
            case "details":
                if(this.project != null)
                    // go to version Details
                    this.appRouter.navigate('/projects/'+this.project.id + "/versions/"+menu.version.id);
                break;
            case "see-project":
                // navigate
                if(menu.version != null){
                    this.versionsSrv.getProject$(menu.version).subscribe((originalProject: Objects.Request) => {
                        console.debug(" the origin project of the version is ",originalProject);
                        if(originalProject != null)
                            this.appRouter.navigate('/projects/'+originalProject.id);
                    });
                }
                break;
            case "add-project":
                if(menu.version != null){
                    this.AddProjectSrv.clear();
                    this.appRouter.navigate('/projects/add', { queryParams: { version: menu.version.id } });
                }
                break;
        }
    }

    onFileClick(version: Objects.Version,file: Objects.File){
        // console.debug(" versions click file preview ",file);
        if (file != null && this.project != null){
            // set this url to preview version FILE
            this.appRouter.navigate(version.id + "/files/"+file.id,{ relativeTo: this.activatedRoute});
        }
    }


    public getFeedbacks(version: Objects.Version){
        return this.feedbacks != null ? this.feedbacks.filter((f: VersionShareItem) => f.version.id == version.id) : null;
    }

    public uploadedCheck(version: Objects.Version){
        return this.uploadedVersions ? this.uploadedVersions.some((uploadVersion: Objects.Version) => uploadVersion.id == version.id) : [];
    }

    public updateVersionStatus(status, version){
        this.projectsSrv.setVersionStatus(this.related.id,version,status)
        

    }

    protected updateMenu(item: ThreeDotsMenuItem, addItem:boolean = true) {
        this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
        if(addItem){
            this.menu.push(item);
        }
    }

    // this track function should prevent redrawn loops on relateds when display the list.
    protected trackByFn(index: number, version: Objects.Version): any {
        return version.id; // the unique identifier
    }

}
